import { useEffect, useState } from "react";
import PolarChart from "../charts/PolarChart";

export default function AsalKabupaten({ data }) {
  const [graphData, setGraphData] = useState({
    labels: [],
    datasets: []
  })

  useEffect(() => {
    const mapData = {}
    const rawData = {
      labels: [],
      datasets: [
        {
          label: '',
          data: [12, 19, 3, 5, 2, 3],
          backgroundColor: [
            'rgba(4,135,55, 1)',
            'rgba(199,183,147, 1)',
            'rgba(245,245,213, 1)',
            'rgba(147,199,183, 1)',
            'rgba(4,235,122, 1)',
            'rgba(163,182,138, 1)',
          ],
          borderWidth: 0,
        },
      ],
    };
    data.map(item => {
      if (mapData[item.nama_kab] !== undefined) {
        mapData[item.nama_kab] += 1
      } else {
        mapData[item.nama_kab] = 1
      }
      return item
    })
    rawData.labels = Object.keys(mapData)
    rawData.datasets[0].data = []
    rawData.labels.map(item => {
      rawData.datasets[0].data.push(((mapData[item]/data.length)*100).toFixed(1))
      return item
    })
    setGraphData(rawData)
  }, [data]);

  return <PolarChart data={graphData} />
}